import React from "react";
import { View } from '../../../components/templates/View';
import { CDHome, CDHomeV2, CMHome, CMHomeV2 } from '../organisms';
import { useViewport, useVersion } from "../../../hooks";

const Home = () => {

    const { width } = useViewport();
    const { version } = useVersion();

    // Debug: verificar versión
    if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
        console.log('Home - Width:', width, 'Version:', version, 'Should use mobile:', width <= 850);
        // #region agent log
        fetch('http://127.0.0.1:7244/ingest/196f09a7-27bd-4831-a9ef-ab53d9b665ae',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'Home.tsx:13',message:'Decisión de renderizado',data:{width:width,version:version,isMobile:width<=850,willRenderDesktop:width>850,willRenderMobile:width<=850,willRenderV2:version==='v2',componentToRender:width>850?(version==='v2'?'CDHomeV2':'CDHome'):(version==='v2'?'CMHomeV2':'CMHome')},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
        // #endregion
    }

    // Para v2: SIEMPRE usar versión desktop, sin importar el tamaño
    // Para v1: usar lógica normal (desktop > 850px, móvil <= 850px)
    const ComponentToRender = version === 'v2' 
        ? CDHomeV2  // v2 siempre desktop
        : (width > 850 ? CDHome : CMHome);  // v1 usa lógica normal

    return (
        <View children={<ComponentToRender />} />
    );
}

export default Home;